
export default {
    name: 'hypothese-diagnostic',
    components: {
    },
    props: ['consultation', 'is_printable'],
    data () {
        return {
            loading: false,
            diagnosis: {
                diagnostic: null,
                hypotheses_diagnostiques:null
            },

            diagnostic_loading: true,
            diagnostic_is_empty: false,

            hypothese_is_empty: false,
            hypothese_loading: true
        }
    },

    computed: {
        consultationEnCours(){
            return this.$store.getters["consultationPatientEnCours"]
        },

        consultationDiagnosticsHistorique() {
            return this.$store.getters["consultationDiagnosticsHistorique"]
        },

        consultationHypotheseHistorique() {
            return this.$store.getters["consultationHypotheseHistorique"]
        }
    },

    async mounted () {
        // Hypotheses diagnostiques
        await this.$store.dispatch("getConsultationDiagnostics", 
            { consultation_id:this.consultation.id, enCours:false, est_diagnostic: 0 }
        ).then(() => {
            if (this.consultationHypotheseHistorique.length > 0) {
                this.hypothese_is_empty = false
            } else {
                this.hypothese_is_empty = true
            }
            this.hypothese_loading = false
        }) 
        
        // Diagnostic
        await this.$store.dispatch("getConsultationDiagnostics", 
            { consultation_id:this.consultation.id, enCours:false, est_diagnostic: 1 }
        ).then(() => {
            if (this.consultationDiagnosticsHistorique.length > 0) {
                this.diagnostic_is_empty = false
            } else {
                this.diagnostic_is_empty = true
            }
            this.diagnostic_loading = false
        }) 
        
    },

    methods: {

    }
}
